export enum ChartType {
  LINE,
  BAR,
  PERCENTAGE_BAR,
}
